;(function () {
  const components = {
    cartLineItemAction: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', async (e) => {
        e.preventDefault()

        SAXX.App.emit(SAXX.Events.ThemeEnqueue, null, async () => {
          node.closest('.cart-line-items').classList.add('updating')

          const response = await SAXX.Library.UpdateItemInCart({
            id: node.getAttribute('data-id'),
            quantity: Number(node.getAttribute('data-quantity')),
          })

          if (!response || response.status === 'bad_request') {
            node.disabled = false
            return ctx.emit(SAXX.Events.CartUpdatingError, null)
          }

          ctx.emit(SAXX.Events.CartUpdated, null, {
            cart: response,
            addedLineItems: response.items,
          })
        })
      })
    }),
    cartDrawerUpdate: SAXX.Init.Component((node, ctx) => {
      ctx.on(
        [SAXX.Events.DrawerControlInteraction, 'theme:localizedCartUpdate'],
        (_, details) => {
          if (details?.cartUpdating) {
            node.querySelector('.cart-line-items').classList.add('updating')
          }
        },
      )

      ctx.on(SAXX.Events.CartUpdated, (_, { cart } = { cart: {} }) => {
        const cartMarkup = new DOMParser().parseFromString(
          cart?.sections['cart-drawer'],
          'text/html',
        )

        node.querySelectorAll('[data-update-section]').forEach((section) => {
          const sectionName = section.getAttribute('data-update-section')
          const sectionMarkup = cartMarkup?.querySelector(
            `[data-update-section="${sectionName}"]`,
          )

          if (!sectionMarkup) return

          section.replaceWith(sectionMarkup)
        })

        if (window.nostojs) {
          window.nostojs((api) => {
            api.loadRecommendations()
          })
        }

        if (typeof OnwardSetup === 'function') {
          window.onwardApp.cartChanged(cart)
        }

        const codeHasErrored = cart?.discount_codes?.filter(
          ({ applicable }) => !applicable,
        ).length

        if (codeHasErrored) {
          node.querySelector('.discount-code-error').innerText =
            SAXX.Localization.DiscountCodeError
        }

        SAXX.App.mount()
      })

      ctx.on(SAXX.Events.CartUpdatingError, (_, { cart } = { cart: {} }) => {
        node.querySelector('.cart-line-items').classList.remove('updating')
        node.querySelector('[data-error-section]').innerHTML =
          SAXX.Localization.AddToCartError
        setTimeout(() => {
          node.querySelector('[data-error-section]').innerHTML = ''
        }, 5000)
      })
    }),
    cartDrawerStickyFooter: SAXX.Init.Component((node, ctx) => {
      ctx.on(SAXX.Events.CartUpdated, (_, { cart } = { cart: {} }) => {
        node.classList.toggle('hidden', cart.item_count === 0)
      })
    }),
    cartDrawerProductCardAction: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('change', async () => {
        ctx.emit(SAXX.Events.DrawerControlInteraction, null, {
          controlElement: 'slide-out-cart',
          cartUpdating: true,
        })

        SAXX.App.emit(SAXX.Events.ThemeEnqueue, null, async () => {
          const response = await SAXX.Library.AddItemToCart({
            node,
            inputQuery: 'input[value="{id}"]',
          })

          if (!response || response.status === 422) {
            return ctx.emit(SAXX.Events.CartUpdatingError, null, {
              cart: response,
            })
          }

          ctx.emit(SAXX.Events.CartUpdated, null, { cart: response })

          node
            .querySelectorAll('.quick-shop--input')
            .forEach((input) => (input.checked = false))
        })
      })
    }),
    cartGiftWithPurchaseTrigger: SAXX.Init.Component((node, ctx) => {
      ctx.on('gwp:offerUpdate', (_, { offerResults }) => {
        node.classList.toggle('hidden', offerResults.valid.length === 0)
      })

      node.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault()
        ctx.emit(SAXX.Events.ModalControlInteraction, null, {
          controlElement: 'gift-with-purchase',
        })
      })
    }),
    cartDrawerDiscountForm: SAXX.Init.Component((node, ctx) => {
      const codeInputField = node.querySelector('#cart-drawerDiscountCode')

      codeInputField.addEventListener('focus', () => {
        node.querySelector('.discount-code-error').innerText = ''
      })

      node.addEventListener('submit', async (e) => {
        e.preventDefault()
        SAXX.App.emit(SAXX.Events.ThemeEnqueue, null, async () => {
          const formData = new FormData(node)
          const codes = new Set([formData.get('cart-drawerDiscountCode')])
          formData
            .get('cart-drawerDiscountPreviousCodes')
            .split(',')
            .forEach((code) => codes.add(code))

          const response = await SAXX.Library.UpdateCart({
            discount: Array.from(codes).join(','),
          })

          if (!response || response.status === 422) {
            node.querySelector('#cart-drawerDiscountCode').value = ''

            return ctx.emit(SAXX.Events.CartUpdatingError, null, {
              cart: response,
            })
          }

          ctx.emit(SAXX.Events.CartUpdated, null, { cart: response })
        })
      })
    }),
    cartDrawerDiscountRemove: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', async (e) => {
        e.preventDefault()
        SAXX.App.emit(SAXX.Events.ThemeEnqueue, null, async () => {
          const codes = JSON.parse(node.getAttribute('data-updated-discounts'))

          const response = await SAXX.Library.UpdateCart({
            discount: Array.from(codes).join(','),
          })

          if (!response || response.status === 422) {
            return ctx.emit(SAXX.Events.CartUpdatingError, null, {
              cart: response,
            })
          }

          ctx.emit(SAXX.Events.CartUpdated, null, { cart: response })
        })
      })
    }),
    cartDrawerProductRecommendations: SAXX.Init.Component((node, ctx) => {
      const fetchRecommendations = (productId = null) => {
        if (!productId) {
          node.classList.add('no-placement')
          return
        }

        const cardTarget = node.querySelector('[data-loading-target]')

        fetch(
          `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&section_id=recommended-products`,
        )
          .then((res) => {
            if (!res.ok) throw new Error(`Fetch error! ${res.status}`)
            return res.text()
          })
          .then((response) => {
            const section = new DOMParser().parseFromString(
              response,
              'text/html',
            )
            cardTarget.innerHTML = section.querySelector(
              '[data-loading-target]',
            ).innerHTML

            new SAXX.Library.Carousel(
              node.querySelector('.recommended-products--container'),
            )

            SAXX.App.mount()
            node.classList.remove('no-placement')
          })
          .catch((e) => {
            console.error(e)
            node.classList.add('no-placement')
          })
          .finally(() => {
            node.classList.remove('loading')
          })
      }

      fetchRecommendations(node.getAttribute('data-initial-product-id'))
      ctx.on(SAXX.Events.CartUpdated, (_, { cart } = { cart: {} }) => {
        if (cart.items.length === 0) {
          fetchRecommendations(node.getAttribute('data-initial-product-id'))
          return
        }

        const updatededID = cart.items[0].product_id
        if (node.getAttribute('data-product-id') === updatededID) return

        node.setAttribute('data-product-id', updatededID)
        fetchRecommendations(updatededID)
      })
    }),
    cartDrawerInstallmentsUpdate: SAXX.Init.Component((node, ctx) => {
      const message = node.querySelector('shopify-payment-terms')

      ctx.on(SAXX.Events.CartUpdated, (_, { cart } = { cart: {} }) => {
        if (message) {
          const meta = JSON.parse(message.getAttribute('shopify-meta'))
          meta.full_price = SAXX.Library.FormatMoney(cart.total_price, true)
          message.setAttribute('shopify-meta', JSON.stringify(meta))
        }
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
